import { filter } from "rxjs";
import { WalletLockedEvent, WalletUnlockedEvent, } from "../models/blade";
import { BaseConnectorStrategy } from "../strategies/base-connector.strategy";
import { WalletConnectService } from "../wallet-connect/wallet-connect.service";
export class WalletConnectStrategy extends BaseConnectorStrategy {
    constructor(meta, projectId) {
        super();
        this.signers = [];
        this.subscriptions = [];
        this.walletConnectService = new WalletConnectService(meta, projectId);
    }
    onWalletLocked(callback) {
        const lockedSub = this.walletConnectService.$events
            .pipe(filter((e) => e.name === WalletLockedEvent))
            .subscribe(callback);
        this.subscriptions.push(lockedSub);
    }
    onWalletUnlocked(callback) {
        const updatedSub = this.walletConnectService.$events
            .pipe(filter((e) => e.name === WalletUnlockedEvent))
            .subscribe(callback);
        this.subscriptions.push(updatedSub);
    }
    async createSession(params) {
        this.signers = await this.walletConnectService.initWithModal(params === null || params === void 0 ? void 0 : params.network);
        return this.signers.map(s => s.getAccountId().toString());
    }
    async killSession() {
        this.subscriptions.forEach(s => s.unsubscribe());
        this.subscriptions = [];
        await this.walletConnectService.destroySession();
    }
    get initialized() {
        return Boolean(this.walletConnectService.getClient());
    }
}
